import React, { useState } from "react";
import KebabIcon from "../../../../assets/svg/icons/common/kebab";
import DropDown from "../../../../components/DropDown/DropDown";
import SkeletonLoader from "../../../../components/skeleton-loader";
import styles from "./styles.module.scss";

const EquipmentBrandCard = ({
  equipment,
  brand = false,
  image,
  noShadow = false,
  disabled = false,
  selectedClass = "",
  equipmentRef = null,
  isActive = false,
  isSelected = false,
  onClick = null,
  showCheckbox = false,
  checkboxOnChange = null,
  showDropdown = false,
  dropdownOptions = [],
  dropdownOnChange = null,
}) => {
  const [imageLoading, setImageLoading] = useState(true);
  return (
    <article
      className={`${styles.equipmentBrandCard} ${selectedClass} ${
        noShadow && styles.noShadow
      } ${disabled && styles.disabled} ${isActive && styles.active}`}
      ref={equipmentRef}
      onClick={onClick ?? null}
    >
      <div className={styles.imageContainer}>
        {imageLoading && (
          <SkeletonLoader
            component="div"
            width="100%"
            height="100%"
            borderRadius="0.5rem"
            style={{
              transform: "scale(1, 1)",
            }}
            className={styles.imageSkeleton}
          />
        )}

        {!imageLoading && showCheckbox && (
          <input
            className={styles.checkbox}
            type="checkbox"
            checked={isSelected}
            onChange={checkboxOnChange}
            data-checkbox
          />
        )}

        {!imageLoading && showDropdown && (
          <div className={styles.dropdownContainer}>
            <DropDown
              options={dropdownOptions}
              onChange={dropdownOnChange}
              size="small"
              bgColor="transparent"
            >
              <KebabIcon />
            </DropDown>
          </div>
        )}

        <img
          src={equipment.image}
          alt={`${equipment.name} logo`}
          onLoad={() => setImageLoading(false)}
          onError={() => setImageLoading(false)}
          style={{ display: imageLoading ? "none" : "block" }}
        />
      </div>

      <div className={styles.nameArea}>
        <h1 className={styles.title}>{equipment.name}</h1>
        <p className={styles.description}>
          {brand && (
            <>
              {equipment?.equipments?.length} model
              {equipment?.equipments?.length > 1 ? "s" : ""} available
            </>
          )}

          {!brand && equipment.category}
        </p>
      </div>
    </article>
  );
};

export default EquipmentBrandCard;
